import { CategoryType } from '../components/CategoryLabel/models';
import { ProductTypes } from '../constants';

const formatCartProductType = (type: CategoryType) => {
  let productType = '';
  switch (type) {
    case ProductTypes.membership:
      productType = '1-Year Membership';
      break;
    case ProductTypes.onlineCourse:
      productType = 'Online Course';
      break;
    default:
      // return other types as is
      productType = type;
      break;
  }

  return productType;
};

export default formatCartProductType;
